import './index.less';

import * as React from 'react';

import { Button, Result } from 'antd';

import { Link } from 'react-router-dom';
import { ExceptionStatusType } from 'antd/lib/result';
import { LoadingOutlined } from '@ant-design/icons';

class Exception extends React.Component<any, any> {
  exception = [
    {
      errorCode: '404', errorDescription: '对不起，您访问的页面不存在。',
    },
    { errorCode: '403', errorDescription: '用户无权访问页面。' },
    { errorCode: '500', errorDescription: '网络错误，请稍后重试，若问题始终存在，请联系管理员解决。' },
  ];
  public render() {
    let params = new URLSearchParams(this.props.location.search);
    let { pathname } = this.props.location
    if (pathname == '/account/callback') {
      return <Result
        icon={<LoadingOutlined/>}
      />
    }
    const type = params.get('type');
    let error = this.exception.find(x => x.errorCode === type);
    if (error == null) {
      error = this.exception[0];
    }

    return (
      <Result
        status={error.errorCode as ExceptionStatusType}
        title={error.errorCode}
        subTitle={error.errorDescription}
        extra={
          <Button type="primary">
            <Link
              to={{
                pathname: '/',
              }}
            >
              回到首页
            </Link>
          </Button>}
      />
    );
  }
}

export default Exception;
